import React from 'react';
import PropTypes from 'prop-types';

import V3OfferLineupList from '../V3OfferLineupList';
import V3MobileBottomSheet from './V3MobileBottomSheet';

const V3MobileLineupReorderSheet = ({
  open,
  onClose,
  lineup,
  activeOfferId,
  onSelectOffer,
  onAddArtist,
  onReorder,
}) => {
  const handleSelectAndClose = (id) => {
    onSelectOffer(id);
    onClose();
  };
  const handleAddAndClose = () => {
    onAddArtist();
    onClose();
  };

  return (
    <V3MobileBottomSheet open={open} onClose={onClose}>
      <div
        className="add-artist-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lineup-reorder-title"
        data-testid="lineup-reorder-sheet"
      >
        <header className="add-artist-modal__header">
          <div>
            <h2 className="add-artist-modal__title" id="lineup-reorder-title">Reorder lineup</h2>
            <p className="add-artist-modal__desc">Drag artists to change support order.</p>
          </div>
          <button
            type="button"
            className="add-artist-modal__close"
            aria-label="Done"
            onClick={onClose}
            data-testid="lineup-reorder-done"
          >
            Done
          </button>
        </header>
        <div className="add-artist-modal__body">
          <V3OfferLineupList
            lineup={lineup}
            activeOfferId={activeOfferId}
            onSelectOffer={handleSelectAndClose}
            onAddArtist={handleAddAndClose}
            onReorder={onReorder}
          />
        </div>
      </div>
    </V3MobileBottomSheet>
  );
};

V3MobileLineupReorderSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  lineup: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeOfferId: PropTypes.number,
  onSelectOffer: PropTypes.func.isRequired,
  onAddArtist: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
};

V3MobileLineupReorderSheet.defaultProps = {
  activeOfferId: null,
};

export default V3MobileLineupReorderSheet;
